
import gql from 'graphql-tag'
export default gql`
mutation uploadFile($files: [ManualS3ObjectInput!]!) {
    uploadFile(files: $files )
  }`
  